// libs
import { styled } from '@nykaa/ui-components';
import { BASE_WIDGET_PADDING_MOBILE } from 'components/AdPlatformWidgets/constants';

// styles
import { FONTS, DWEB_MAX_WIDTH, BREAKPOINTS } from 'shared/styles/base';

export const Container = styled.div<{ alignment: string }>`
  font-family: ${FONTS.BASE_FAMILY};
  width: 100%;
  max-width: ${DWEB_MAX_WIDTH}px;
  ${({ theme }) => theme.typography.type240};
  font-weight: 500;
  text-transform: capitalize;
  padding: 0;
  margin-top: 56px;
  padding-right: 15px;
  text-align: ${(props) => props.alignment};

  @media (max-width: ${BREAKPOINTS.DESKTOP}px) {
    margin-top: ${30 - BASE_WIDGET_PADDING_MOBILE / 2}px;
  }

  @media (max-width: 768px) {
    ${({ theme }) => theme.typography.type200};
    padding: 5px 5px 0px 5px;
  }
`;
